import React from 'react';
import * as _ from './style';
import SplashLogo from 'assets/image/SplashLogo';

const Splash = () => {
  return (
    <_.Splash_Container>
      <SplashLogo />
    </_.Splash_Container>
  );
};

export default Splash;
